import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      if (sessionStorage.getItem("g2a_install_dismissed")) return;
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    sessionStorage.setItem("g2a_install_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed z-50 bottom-20 md:bottom-5 inset-x-3 md:inset-x-auto md:right-5 md:w-80 rounded-2xl bg-white border border-black/10 shadow-2xl p-4 flex items-center gap-3 animate-fade-up"
    >
      <img src="/icon-192.png" alt="" className="h-11 w-11 rounded-xl" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm font-display leading-tight">Install Go2Alanya</p>
        <p className="text-xs text-muted-foreground">Add to your home screen for instant access.</p>
      </div>
      <button data-testid="install-accept" onClick={install} className="rounded-full bg-primary text-primary-foreground text-sm font-medium px-3 py-2 flex items-center gap-1 shrink-0">
        <Download className="h-4 w-4" /> Install
      </button>
      <button data-testid="install-dismiss" onClick={dismiss} className="text-muted-foreground shrink-0"><X className="h-4 w-4" /></button>
    </div>
  );
};
